export interface ValidateNewJobTerminalsAndLocationRequest  {
    jobId: string;
    terminalName: string;
  }
  